export default __webpack_public_path__ + "static/Braathens-ae5a217671b877dc81d797640d3e0974.png";